//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.Artist

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The lineup model
* 
* @param headliners The headliners of the event (top performers)
* @param performers The performers of the event (normal performers)
* @param supporters The supporters of the event (not widely known performers)
* @param visuals The visual artists of the event
*/
@Serializable

data class Lineup (


      /* The headliners of the event (top performers) */
    @SerialName(value = "headliners") val headliners: kotlin.collections.Set<Artist>? = null,


      /* The performers of the event (normal performers) */
    @SerialName(value = "performers") val performers: kotlin.collections.Set<Artist>? = null,


      /* The supporters of the event (not widely known performers) */
    @SerialName(value = "supporters") val supporters: kotlin.collections.Set<Artist>? = null,


      /* The visual artists of the event */
    @SerialName(value = "visuals") val visuals: kotlin.collections.Set<Artist>? = null


) {




  }

